import * as React from "react"
import { GLASS_LAYER } from "@digits-shared/DesignSystem/Containers/Glass"
import styled from "styled-components"
import { InviteClientModal } from "src/frontend/components/OS/Applications/ClientPortal/InviteFlow/InviteClientModal"
import { Layout } from "src/frontend/components/OS/Home/Operator/Layout"
import { LayoutHeader } from "src/frontend/components/OS/Home/Operator/LayoutHeader"
import { useFetchPortalAndLayout } from "src/frontend/components/Shared/Portals/State/useFetchPortalAndLayout"
import { useInviteClientsModalControls } from "src/frontend/components/Shared/Portals/State/useInviteClientsModalControls"
import { useResetPortalPerLE } from "src/frontend/components/Shared/Portals/State/useResetPortalPerLE"
import { Desktop } from "src/frontend/components/Shared/Responsive/Desktop"

const ModuleWrapper = styled.div`
  .desktop & {
    ${GLASS_LAYER};
    padding: 15px 20px 0;
  }
  .mobile & {
    padding: 0 12px 24px;
  }
  border-radius: inherit;
  display: flex;
  flex-direction: column;
`

export const PortalContent: React.FC = () => {
  useResetPortalPerLE()
  useFetchPortalAndLayout()

  const { shouldShow: showInviteClientModal, hideModal } = useInviteClientsModalControls()

  return (
    <ModuleWrapper>
      <Desktop>
        {showInviteClientModal && (
          <InviteClientModal showViewUsers onClose={hideModal} onDone={hideModal} />
        )}
      </Desktop>

      <LayoutHeader />
      <Layout />
    </ModuleWrapper>
  )
}
